import PosthogService from '~/services/posthog/PosthogService';

export interface IPermanentHireRequestSubmittedPayload {
  professionType: string;
  startDate: string;
  scheduleType: string;
}

/**
 * Fires when an office submits a permanent-hire request
 * Event: dental_portal:permanent_hire:request_submitted
 */
export function firePermanentHireRequestSubmitted(
  payload: IPermanentHireRequestSubmittedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:permanent_hire:request_submitted', {
    profession_type: payload.professionType,
    start_date: payload.startDate,
    schedule_type: payload.scheduleType,
  });
}
